import { memo } from "react";
import { TextField } from "@mui/material";
import { useTheme } from "@mui/material/styles";

function LoginFields({
  email,
  onChangeEmail,
  emailErr,

  userPassword,
  onChangePassword,
  passwordErr,

  onSubmit,
}) {
  const theme = useTheme();

  const renderField = (value, onChange, label, type, error, autoComplete) => {
    const hasError = error && Object.keys(error).length > 0;
    const errorMessage = hasError ? Object.values(error)[0] : "";

    return (
      <TextField
        fullWidth
        required
        type={type}
        placeholder={label}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        error={hasError}
        helperText={errorMessage}
        variant="outlined"
        InputLabelProps={{
          shrink: false,
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
            backgroundColor: "#d7e5f8",

            "& fieldset": {
              border: "none",
            },
          },

          "& .MuiInputBase-input::placeholder": {
            color: theme.palette.text.secondary,
            opacity: 0.8,
          },

          "& .MuiInputBase-input": {
            padding: "15px",
            color: theme.palette.text.secondary,
          },

          "& input:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0 1000px #d7e5f8 inset",
            WebkitTextFillColor: theme.palette.text.secondary,
            borderRadius: "10px",
            transition: "background-color 9999s ease-in-out 0s",
          },

          "& input:-webkit-autofill:hover": {
            WebkitBoxShadow: "0 0 0 1000px #d7e5f8 inset",
          },

          "& input:-webkit-autofill:focus": {
            WebkitBoxShadow: "0 0 0 1000px #d7e5f8 inset",
          },
        }}
      />
    );
  };

  return (
    <form
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          onSubmit();
        }
      }}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "90%",
        gap: "10px",
      }}
    >
      {renderField(
        email,
        onChangeEmail,
        "Email",
        "email",
        emailErr,
        "username",
      )}

      {renderField(
        userPassword,
        onChangePassword,
        "Passwort",
        "password",
        passwordErr,
        "current-password",
      )}
    </form>
  );
}

export default memo(LoginFields);
